import {
  Button,
  Create,
  Form,
  FormInstance,
  Icons,
  Input,
  message,
  Modal,
  Select,
} from "@pankod/refine-antd";
import { useNavigation, useResource, useTranslate } from "@pankod/refine-core";
import "./style.scss";
import { ICodePayload, IPageId } from "interfaces";
import { createRef, useContext, useEffect, useState } from "react";
import CodeEditor from "@uiw/react-textarea-code-editor";
import { LOOPABLE_ITEMS_CODE } from "styleObjects";
import "./style.scss";
import "@uiw/react-textarea-code-editor/dist.css";
import api from "api/api";
import {
  defaultButtonFilled18,
  defaultHeader,
  DefaultModalCancelButton,
  DefaultModalOkayButton,
} from "components";
import { AuthContext, IAuthContext } from "AuthContext";
const { SaveTwoTone, CloseCircleFilled } = Icons;
export const CodeCreate = () => {
  const t = useTranslate();
  const { TextArea } = Input;
  const [selectedPagesID, setSelectedPagesID] = useState<IPageId[]>([]);
  const formRef = createRef<FormInstance>();
  // to prevent react keeping state of _ forms we use keyscount this way new forms will not have _ one values
  // we are setting key to the item itemKey attr
  const { id } = useResource();
  const nav = useNavigation();
  const [initialValues, setInitialValues] = useState<ICodePayload | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [pagesID, setPagesID] = useState<IPageId[]>();
  const [code, setCode] = useState<string>("");
  const [showWarningModal, setShowWarningModal] = useState(false);
  const { languageId } = useContext(AuthContext) as IAuthContext;

  useEffect(() => {
    async function getInitialValues() {
      const response = await api.pages.getAllPagesForDropDown(
        (languageId ?? 0)?.toString()
      );
      if (response.kind === "ok") setPagesID([...response.data]);
      if (id) {
        const response2 = await api.codeSnippets.getCodeSnippet(id as string);
        if (response2.kind !== "ok") return;
        if (response2.data.pages) {
          const tempPages: IPageId[] = [];
          response.data.map((item: IPageId) => {
            if (response2.data.pages.includes(item.id)) tempPages.push(item);
            return item;
          });
          setSelectedPagesID(tempPages);
        }
        setInitialValues(response2.data);
      }
    }
    getInitialValues();
  }, [id, languageId]);

  async function createNewCode() {
    let payLoad: ICodePayload = {};
    LOOPABLE_ITEMS_CODE(t).map((item) => {
      if (formRef.current?.getFieldValue(item.name))
        payLoad[item.name] = formRef.current?.getFieldValue(item.name);
      return item;
    });
    const newPay: any = payLoad;
    newPay.pages = newPay.pages ? [newPay.pages] : [];
    if (selectedPagesID.length !== 0) {
      const filteredIDs: number[] = [];
      selectedPagesID.map((item) => filteredIDs.push(item.id));
      newPay.pages = filteredIDs;
    }
    const response = await api.codeSnippets.postCodeSnippet(newPay);
    if (response.kind === "ok") setShowModal(true);
    if (response.kind !== "ok") message.error(response.kind);
  }

  return (
    <Create
      actionButtons={[
        <Button
          icon={<SaveTwoTone color="white" twoToneColor="white" />}
          style={defaultButtonFilled18}
          onClick={createNewCode}
        >
          {t("buttons.save")}
        </Button>,
      ]}
      pageHeaderProps={{
        onBack: () => setShowWarningModal(true),
        title: defaultHeader(t("code:create.title")),
      }}
    >
      {(!id || (initialValues && pagesID)) && (
        <Form layout="vertical" ref={formRef}>
          {LOOPABLE_ITEMS_CODE(t).map((name) =>
            name.name === "pages" ? (
              <Form.Item
                label={name.label}
                tooltip={name.tooltip}
                name={name.name}
                key={name.label}
              >
                <Select
                  options={pagesID?.map((item) => {
                    return {
                      label: item.name,
                      value: item.id,
                    };
                  })}
                  onSelect={(e: number) => {
                    setSelectedPagesID((old) => {
                      if (!pagesID) return old;
                      const includes = old.some((item) => item.id === e);
                      const filtered = includes
                        ? [...old]
                        : [...old, ...pagesID?.filter((item) => item.id === e)];
                      return filtered as IPageId[];
                    });
                  }}
                />
                <div className="selectedPageID-wrapper">
                  {selectedPagesID.map((item) => {
                    return (
                      <div className="selectedPageID">
                        <h1> {item.name}</h1>{" "}
                        {
                          <CloseCircleFilled
                            className="deleteIcon"
                            onClick={() => {
                              setSelectedPagesID((old) =>
                                old.filter((e) => item.id !== e.id)
                              );
                            }}
                          />
                        }
                      </div>
                    );
                  })}
                </div>
              </Form.Item>
            ) : name.name === "headOrBody" ? (
              <Form.Item
                label={name.label}
                tooltip={name.tooltip}
                name={name.name}
                key={name.label}
                initialValue={initialValues ? initialValues[name.name] : 1}
              >
                <Select
                  options={[
                    {
                      label: "Head",
                      value: 1,
                    },
                    {
                      label: "Body",
                      value: 2,
                    },
                  ]}
                />
              </Form.Item>
            ) : name.name === "description" ? (
              <Form.Item
                label={name.label}
                tooltip={name.tooltip}
                name={name.name}
                key={name.label}
                initialValue={initialValues ? initialValues[name.name] : ""}
              >
                <TextArea rows={5} />
              </Form.Item>
            ) : name.name === "code" ? (
              <Form.Item
                label={name.label}
                tooltip={name.tooltip}
                name={name.name}
                key={name.label}
                initialValue={initialValues ? initialValues[name.name] : ""}
              >
                <CodeEditor
                  value={code}
                  language="js"
                  placeholder=""
                  onChange={(evn) => setCode(evn.target.value)}
                  padding={15}
                  className="w-tc-editor-var"
                  style={{
                    fontSize: 16,
                    backgroundColor: "#111",
                    border: "1px solid #999",
                    borderRadius: "5px",
                    minHeight: "125px",
                    caretColor: "white",
                    fontFamily:
                      "ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
                  }}
                />
              </Form.Item>
            ) : (
              <Form.Item
                label={name.label}
                tooltip={name.tooltip}
                name={name.name}
                key={name.label}
                initialValue={initialValues ? initialValues[name.name] : ""}
              >
                <Input />
              </Form.Item>
            )
          )}
        </Form>
      )}
      <Modal
        closable
        title={t("code:create.successModal.title")}
        visible={showModal}
        onOk={() => nav.goBack()}
        onCancel={() => nav.goBack()}
        footer={[<DefaultModalOkayButton onClick={() => nav.goBack()} />]}
      >
        {t("code:create.successModal.message")}
      </Modal>
      <Modal
        closable
        title={t("code:create.warningModal.title")}
        visible={showWarningModal}
        onOk={() => nav.goBack()}
        onCancel={() => setShowWarningModal(false)}
        footer={[
          <DefaultModalCancelButton
            onClick={() => setShowWarningModal(false)}
          />,
          <DefaultModalOkayButton onClick={() => nav.goBack()} />,
        ]}
      >
        <p>{t("code:create.warningModal.message")}</p>
      </Modal>
    </Create>
  );
};
